import { render, staticRenderFns } from "./Triggerfish.vue?vue&type=template&id=b8cc1c54&"
import script from "./Triggerfish.vue?vue&type=script&lang=js&"
export * from "./Triggerfish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports